import { Property, PropertyType } from '../../../../base/types';

import { IProperty } from '../../../../base/models';

export const ShuttleBookingProperties: IProperty[] = [
    { id: Property.CancelPageLink, name: 'Navigate To on Bookings', type: PropertyType.PageLink },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.BookingStatus, name: 'booking status', type: PropertyType.Number },
    { id: Property.LatestRecord, name: 'latest record', type: PropertyType.Boolean },
    { id: Property.TableLookup, name: 'Table Lookup', type: PropertyType.TableLookup },
]
